import React, { useState } from "react";

import { useSelector } from "react-redux";
import {
  RideSelectTextField,
  RideSelect,
  RideTextField,
} from "@rimac-seguros/ride-system-components";

import {
  DOCUMENT_TYPE_DNI,
  getDocumentType,
  LIST_DOCUMENT_TYPE,
} from "@/constants/list-document-type";
import { useGetInfoBeneficiary } from "@/hooks/useGetInfoBeneficiary";
import helpers from "@/utils/helpers";

export const FormDocument = ({
  index,
  register,
  prefixControl,
  prefixError,
  watch,
  getValues,
  loadingSave,
  setValue,
  setError,
  resetField,
  setLoading,
  setHasFetchedPersonData,
  setIsValidBasicInformation,
  setIsValidAdditionalData,
  setIsValidUbigeo,
  setIsValidDocument,
  resetAttempts,
  isVCD,
  product,
}) => {
  const isVE = helpers.validateVidaEndosable();
  const [previousDocumentNumber, setPreviousDocumentNumber] = useState("");

  const documentType = watch(`${prefixControl}.documentType`);

  const { userData } = useSelector((state) => state.vida);
  const { numeroDocumento, documento } = userData;
  const documentNumberTitular = numeroDocumento || documento;

  const { getPersonData } = useGetInfoBeneficiary({
    prefixControl,
    setValue,
    setError,
    setIsValidDocument,
    isVCD,
    product,
  });

  const handleInputDocument = (e) => {
    const el = e.target;
    el.value =
      documentType === DOCUMENT_TYPE_DNI.value
        ? el.value.replace(/[^0-9]/g, "")
        : el.value.replace(/[^A-Za-z0-9]/g, "");
  };

  const handleBlurDocument = async (e) => {
    const { value } = e.target;
    const invalidDocumentMessage = "El documento ingresado ya está registrado"
    const minLength = getDocumentType(documentType)?.minLength;

    if (!value || (minLength && value.length < minLength)) return;

    if (!validateIfDocumentExist(value)) {
      setIsValidDocument(false);
      setTimeout(() => {
        setError(`${prefixControl}.documentNumber`, {
          type: "isValidDocument",
          message: isVE ? invalidDocumentMessage : "El documento está registrado. Ingresa otro.",
        });
        helpers.getTagLog(isVE ? invalidDocumentMessage : "El documento está registrado. Ingresa otro", "trackLog");
      }, 100);
      return;
    }

    if (prefixError?.documentNumber && value === previousDocumentNumber) return;

    setPreviousDocumentNumber(value);
    setLoading(true);
    setHasFetchedPersonData(false);
    resetFields();
    resetAttempts();

    try {
      const {
        isValidBasicInformation,
        isValidUbigeo,
        isValidAdditionalData,
      } = await getPersonData(watch(`${prefixControl}.documentType`), value);

      setIsValidBasicInformation(isValidBasicInformation);
      setIsValidAdditionalData(isValidAdditionalData);
      setIsValidUbigeo(isValidUbigeo);
    } finally {
      setLoading(false);
      setHasFetchedPersonData(true);
    }
  };

  const handleSelectDocumentType = (event) => {
    resetFields();
    setValue(`${prefixControl}.documentNumber`, "", {
      shouldValidate: true,
    });
    setHasFetchedPersonData(false);
    resetAttempts();
    mappingTagAction(event.label);
  }

  const resetFields = () => {
    const fields = getValues(`beneficiaries[${index}]`);
    Object.keys(fields).forEach((field) => {
      if (["documentNumber", "documentType", "status"].includes(field)) return;
      const key = `${prefixControl}.${field}`;
      resetField(key);
      setValue(key, "");
    });
  };

  const validateIfDocumentExist = (documentNumber) => {
    const documents = getValues()
      .beneficiaries.filter((_, i) => index !== i)
      .map((_) => _.documentNumber);
    return ![...documents, documentNumberTitular].includes(documentNumber);
  };

  const mappingTagAction = (label) => {
    helpers.setActionTag({
      group: product,
      category: isVCD || isVE ? "Elegir beneficiarios" : "Interacciones",
      action: isVCD || isVE ? "click" : "Click",
      label: label,
    });
  }

  return (
    <RideSelectTextField
      label="Ingresa su documento"
      size="large"
      disabled={loadingSave}
      error={!!prefixError?.documentNumber}
      errorMessage={
        prefixError?.documentNumber?.message || "Este campo es obligatorio"
      }
    >
      <RideSelect
        {...register(`${prefixControl}.documentType`, {
          required: true,
        })}
        options={LIST_DOCUMENT_TYPE}
        onSelect={handleSelectDocumentType}
      />
      <RideTextField
        {...register(`${prefixControl}.documentNumber`, {
          required: isVE ? "Ingresa un documento" : "Este campo es obligatorio",
          minLength: {
            value: getDocumentType(documentType)?.minLength,
            message: "Ingresa un documento válido"
          },
          onBlur: handleBlurDocument,
        })}
        autoComplete="off"
        maxLength={getDocumentType(documentType)?.maxLength}
        onInput={handleInputDocument}
      />
    </RideSelectTextField>
  );
};
